import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { IdentificationSection } from './components/IdentificationSection';
import { PerspectiveShift } from './components/PerspectiveShift';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBadges } from './components/TrustBadges';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel installation
    const metaPixelId = '1225428543097695';
    // Meta Pixel base code
    const fbq = function () {
      // @ts-ignore
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      window.fbq = fbq;
      // @ts-ignore
      fbq.push = fbq;
      // @ts-ignore
      fbq.loaded = true;
      // @ts-ignore
      fbq.version = '2.0';
      // @ts-ignore
      fbq.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    fbq('init', metaPixelId);
    // @ts-ignore
    fbq('track', 'PageView');
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="w-full min-h-screen bg-dark text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <PainSection data-id="element-4" />
      <IdentificationSection data-id="element-5" />
      <PerspectiveShift data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <BenefitsSection data-id="element-8" />
      <UrgencySection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <TrustBadges data-id="element-13" />
      <FAQSection data-id="element-14" />
      <Footer data-id="element-15" />
      <PurchasePopup data-id="element-16" />
    </div>;
}